import { SelectionChangedEvent } from "ag-grid-community";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { convertDateToDateTimeForComponent } from "presentation/utils/timeUtil";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import NbisDateTimePickerComponent from "presentation/view/components/NbisDateTimePickerComponent";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useMemo, useRef, useState } from "react";
import { HPHButton, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";
import { useChargeDetailTracked } from "presentation/store/ChargeDetailMaintenance/ChargeDetailProvider";
import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { CHARGE_DETAIL_PAIDTHROUGHDATE_COL_DEF } from "presentation/constant/ChargeDetailMaintenance/UpdatePaidThroughDateColumnDefinition";
import { ChargeDetailConstant } from "presentation/constant/ChargeDetailMaintenance/ChargeDetailConstant";
import { ChargeDetailEntity } from "domain/entity/ChargeDetailMaintenance/ChargeDetailEntity";
import { PaidThroughDateState } from "presentation/model/ChargeDetailMaintenance/ChargeDetailModel";
import { useChargeHeaderMaintenanceTracked } from "presentation/store/ChargeHeaderMaintenance/ChargeHeaderMaintenanceProvider";
import { EMPTY_SEARCH_MODE_ENTITY } from "domain/entity/ChargeDataEnquiry/SearchModeEntity";
import { useChargeHeaderMaintenanceVM } from "presentation/hook/ChargeHeaderMaintenance/useChargeHeaderMaintenanceVM";
import { MessageConstant } from "presentation/constant/MessageConstant";

const UpdatePaidThroughDatePanel = () => {
    const [chargeDetailState] = useChargeDetailTracked();
    const [chargeHeaderState] = useChargeHeaderMaintenanceTracked();
    const chargeDetailVM = useChargeDetailVM();
    const chargeHeaderVM = useChargeHeaderMaintenanceVM();
    const { paidThroughDateMap, selectedPaidThroughDateMap, chargeBatchUpdate } = chargeDetailState;
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const messageBarVM = useMessageBarVM();
    const gridRef: any = useRef(null);

    const [anainfoState] = useANAInfoTracked();
    const { operatingUnit } = anainfoState;

    const vaildation = useCallback(() => {
        let isAllowUpdatePaidThroughDate = false;

        chargeDetailState.selectedChargeDetails.forEach((entity) => {
            if (operatingUnit === "SAPT" || operatingUnit === "KICT") {
                if (entity.dtlState === "E" || entity.dtlState === "R" || entity.dtlState === "F" || entity.dtlState === "T" || entity.dtlState === "W") {
                    if (entity.chargeType === "ITM" || (entity.chargeType === "CC" && entity.subChargeType === "ITM")
                        || (entity.chargeType === "DEM" && entity.subChargeType === "DEI")
                        || (entity.chargeType === "RFH" && (entity.subChargeType === "PCI" || entity.subChargeType === "PCIH" || entity.subChargeType === "FDC"
                            || ((entity.cntrStatus1 === "IF" || entity.cntrStatus1 === "IM" || entity.cntrStatus1 === "TF" || entity.cntrStatus1 === "TM")
                                && (entity.subChargeType === "T2" || (entity.subChargeType === "T1" && entity.otherSplitId === null)))))
                        || ((entity.chargeType === "CSR") && (entity.subChargeType === "ST" || entity.subChargeType === "DE"))) {
                        isAllowUpdatePaidThroughDate = true;
                    }
                }
            } else {
                if ((entity.dtlState === "E" || entity.dtlState === "R" || entity.dtlState === "F" || (entity.dtlState === "T" && (operatingUnit === "OICT" || operatingUnit === "HPJZ")))) {
                    if ((operatingUnit === "AQCT" || operatingUnit === "RSCT") &&
                        (entity.adjType !== "Cancel Only" && entity.adjType !== "Cancel & Re-bill")) {
                        isAllowUpdatePaidThroughDate = true;
                    } else {
                        isAllowUpdatePaidThroughDate = true;
                    }
                }
            }
        })

        if (operatingUnit !== "SAPT" && operatingUnit !== "KICT") {
            if (!chargeBatchUpdate.paidThroughDate) {
                messageBarVM.showError("Please input the Paid through date time.");
                return false;
            }
        }

        const currentDate = new Date();//dd-MM-yyyy HH:mm:ss
        if (operatingUnit === "SAPT" || operatingUnit === "KICT") {
            if (chargeBatchUpdate.paidThroughDate && chargeBatchUpdate.paidThroughDate < currentDate) {
                messageBarVM.showError("Paid Through Date " + convertDateToDateTimeForComponent(chargeBatchUpdate.paidThroughDate) + " is not allow back date.");
                return false;
            }
        } else {
            let msg = null;
            paidThroughDateMap.forEach((value, key) => {
                if (!value) {
                    msg = "Please input the Paid Through Date.";
                    return false;
                }
                const paidDate = new Date(value);
                if (paidDate && paidDate < currentDate) {
                    if (operatingUnit === "OICT" || operatingUnit === "HPJZ") {
                        msg = "The Paid through date time should not be earlier than the current system date.";
                    } else {
                        msg = "Paid Through Date " + convertDateToDateTimeForComponent(value) + " is not allow back date.";
                    }
                    return false;
                }
            });
            if (msg) {
                messageBarVM.showError(msg);
                return false;
            }
        }

        if (!isAllowUpdatePaidThroughDate) {
            messageBarVM.showError("Just allow update the paid through date for R/F/E/T storage charge except for outbound storage.");
            return false;
        }

        return true;
    }, [chargeDetailState.selectedChargeDetails, operatingUnit, chargeBatchUpdate.paidThroughDate, messageBarVM, paidThroughDateMap]);

    const handleSaveClick = useCallback(async () => {
        if (!vaildation()) {
            return;
        }
        setIsLoading(true);
        // try {
        let newSearchCriteria = chargeDetailState.searchCriteria;
        newSearchCriteria = { ...newSearchCriteria, chargeHdrId: Number(chargeDetailState?.currentChargeHeader?.id ?? chargeHeaderState?.currentChargeHeader?.id) ?? 0 }

        let entityList: ChargeDetailEntity[] = [];
        chargeDetailState.selectedChargeDetails.forEach(item => {
            const cntrNo = item.cntrNo;
            if (cntrNo && paidThroughDateMap && paidThroughDateMap.has(cntrNo)) {
                item.paidThroughDate = paidThroughDateMap?.get(cntrNo) ?? null;
            }
            entityList.push(item);
        });
        chargeDetailVM.onSave(entityList).then((res) => {
            Promise.allSettled([
                chargeDetailVM.getChargeDetails(newSearchCriteria),
                chargeHeaderVM.onSearch({
                    ...chargeDetailState.searchCriteria,
                    id: chargeDetailState?.currentChargeHeader?.id ?? chargeHeaderState?.currentChargeHeader?.id
                }, EMPTY_SEARCH_MODE_ENTITY, true, true)
            ]).finally(() => {
                if (res && res["updatePaidThroughDateFail"]) {
                    const err: string = res["updatePaidThroughDateFail"]?.toString() ?? "";
                    messageBarVM.showError(err.replace("Error:", ""));
                } else {
                    messageBarVM.showSuccess(`Update ${MessageConstant.common.OPERATION_DONE_SUCCESSFUL.replace("{operationDone}", ChargeDetailConstant.Charge.PAID_THROUGH_DATE)}`);
                }
            });
        }).catch(() => {
            setIsLoading(false);
        }).finally(() => {
            setIsLoading(false);
            chargeDetailVM.onPaidThroughDateCloseClick();
        });

    }, [vaildation, chargeDetailState.searchCriteria, chargeDetailState?.currentChargeHeader?.id, chargeDetailState.selectedChargeDetails, chargeHeaderState?.currentChargeHeader?.id, chargeDetailVM, paidThroughDateMap, chargeHeaderVM, messageBarVM]);

    const handClose = useCallback(() => {
        chargeDetailVM.onPaidThroughDateCloseClick();
    }, [chargeDetailVM]);

    const allRows = useMemo<PaidThroughDateState[]>(() => {
        if (!paidThroughDateMap || paidThroughDateMap.size === 0) {
            return [];
        }
        return Array.from(paidThroughDateMap)
            .map(([containerNo, paidThroughDate]) => ({
                cntrNo: containerNo,
                paidThroughDate: paidThroughDate,
            }))
            .sort((a, b) => a.cntrNo.localeCompare(b.cntrNo));
    }, [paidThroughDateMap]);

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        chargeDetailVM.updateSelectedPaidThroughDateRows(selectedRows);
    }, [chargeDetailVM])

    const handApply = useCallback(() => {
        if (!selectedPaidThroughDateMap || selectedPaidThroughDateMap.size === 0) {
            messageBarVM.showError("Please select record(s).");
            return;
        }
        if (!chargeBatchUpdate.paidThroughDate) {
            messageBarVM.showError("Please input the Paid through date time.");
            return;
        }
        chargeDetailVM.onApplyClick(paidThroughDateMap, selectedPaidThroughDateMap, "paidThroughDateMap");
    }, [chargeBatchUpdate, chargeDetailVM, messageBarVM, paidThroughDateMap, selectedPaidThroughDateMap]);

    const updatePaidThroughDatePanelTable =
        <NbisTable
            id='update-paid-through-date-table'
            isNewColumnSetting={false}
            columns={CHARGE_DETAIL_PAIDTHROUGHDATE_COL_DEF?.slice()}
            data={allRows ?? []}
            showPaginator={false}
            editable={false}
            showAddIcon={false}
            showUploadIcon={false}
            showDeleteButton={false}
            showReloadIcon={false}
            selectionMode={false}
            isRowHighligted={true}
            showPreferenceMenu={false}
            showSidebar={false}
            handleSelectionChanged={handleSelectionChange}
            gridHeight="customHeight"
            customHeight="calc(40vh)"
            ref={gridRef}
            rowSelection={"multiple"}
        />

    const memoPaidThroughDate = useMemo(() => {
        if (!paidThroughDateMap || paidThroughDateMap.size === 0) {
            return null;
        }

        return (
            <>
                <CriteriaItemContainer>
                    <div className="im-flex-row-item" style={{ width: "220px", marginBottom: "24px", marginLeft: "15px" }}>
                        <NbisDateTimePickerComponent
                            disabled={false}
                            label={ChargeDetailConstant.Charge.PAID_THROUGH_DATE}
                            width="220px"
                            date={chargeBatchUpdate?.paidThroughDate}
                            fieldName={"paidThroughDate"}
                            errorMessage=""
                            onDateChange={chargeDetailVM.onDatePickerChange}
                        />
                    </div>
                    <HPHButton label={'Apply'} size={'Small'} theme={'Secondary'} onClick={handApply} />
                </CriteriaItemContainer>
            </>
        );
    }, [chargeBatchUpdate?.paidThroughDate, chargeDetailVM.onDatePickerChange, handApply, paidThroughDateMap]);


    return (<div className='side-form-content-wrapper' style={{ height: 'calc(100vh - 8vh - 62px)' }}>
        <div className={'flex-row'}>
            <div className={'flex-row-item flex-row-item-full-width'}>
                <Sidebarheader>
                    <SidebarTitle>{"Update Paid Through Date"}</SidebarTitle>
                </Sidebarheader>
            </div>
        </div>

        {isLoading && <Loader Indicator="Spinner" size="Medium" />}

        <div style={{ marginTop: "-50px" }}>
            <TableWrapper>
                <div style={{ marginLeft: "15px" }}>{updatePaidThroughDatePanelTable}</div>
            </TableWrapper>
        </div>

        <div className={'add-edit-form'}>
            <div className="flex-row-auto">
                <div className={'flex-row-item'}>
                    {memoPaidThroughDate}
                </div>
            </div>
        </div>
        <SidebarActionBar>
            <HPHButton label={'Close'} size={'Small'} theme={'Secondary'} onClick={handClose} />
            <HPHButton label={'Save'} size={'Small'} theme={'Primary'} onClick={() => handleSaveClick()} />
        </SidebarActionBar>
    </div >)
}

export default memo(UpdatePaidThroughDatePanel);